//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            Loading: false,
            person: [],
            person_status: '',
            selectedProperty: {},
            follow_ups_length: 0
        };
    },
    created: function created() {
        Event.$on('archive-view-guest-card', this.archiveViewGuestCard);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('archive-view-guest-card');
    },

    methods: {
        archiveViewGuestCard: function archiveViewGuestCard(item) {
            var $el = this;
            $el.$children[0].$data.showModal = true;
            $el.person = item;
            $el.follow_ups_length = item.follow_ups.length;
            $el.selectedProperty = item.property ? { id: item.property.id, name: item.property.name } : '';
            axios.get('/prototype/guest-cards/' + $el.person.id).then(function (response) {
                $el.person = response.data;
                $el.person_status = response.data.status.status === "Archive" ? "Unarchive" : "Archive";
            });
        },
        changeStatus: function changeStatus($status) {
            var _this = this;

            var form = document.querySelector('form');
            var formData = new FormData(form);
            formData.append("status", $status);
            formData.append("id", this.person.id);
            axios.post('/prototype/person/guest-cards/changeStatus', formData).then(function (response) {
                if (response.data) {
                    _this.$snotify.success('The status was updated');
                    Event.$emit('guest-card-dashboard-updated');
                    Event.$emit('person-archive-updated');
                    Event.$emit('person-updated');
                    Event.$emit('close-full-modal');
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/guest-cards/ArchiveGuestCardDetails.vue
// module id = ypGP
// module chunks = 0 1